import type { ProductUnsecuredLoanConfig } from '../../@types/context/product-unsecured-loan-config.types';

export const unsecuredLoansFiConfig: Omit<
  ProductUnsecuredLoanConfig,
  'fields'
> = {
  rates: {
    min: 0.06,
    low: 6,
    mid: 12,
    high: 20,
    startup_fee: 0,
    monthly_fee: 0,
  },
  config: {
    amount: {
      min: 500,
      max: 70_000,
      default: 40_000,
      step: 500,
    },
    duration: {
      min: 1,
      max: 20,
      default: 15,
      step: 1,
    },
  },
};
